import { Button, Box, Typography } from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';

const PageContainer = styled(Box)({
  padding: '24px'
});

const HeaderBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '24px'
});

const StyledButton = styled(Button)({
  borderRadius: '8px'
});

const ModalBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 500,
  overflow: 'auto',
  height: 600,
  backgroundColor: 'white',
  borderRadius: '12px',
  boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.1)',
  padding: '24px',
  outline: 'none'
});

const FormSectionTitle = styled(Typography)({
  fontWeight: 600,
  marginTop: '20px',
  marginBottom: '10px',
  color: pallet.textGrey
});

export { PageContainer, HeaderBox, StyledButton, ModalBox, FormSectionTitle };
